import Cookies from 'js-cookie'

export const setAuthToken = (token: string) => {
  localStorage.setItem('access_token', token)
  Cookies.set('access_token', token, { expires: 1 }) // 1 day
}

export const removeAuthToken = () => {
  localStorage.removeItem('access_token')
  localStorage.removeItem('refresh_token')
  Cookies.remove('access_token')
}

export const getAuthToken = (): string | null => {
  return localStorage.getItem('access_token')
}

export const isAuthenticated = (): boolean => {
  const token = getAuthToken()
  return !!token
}

export const getUserRole = (): string | null => {
  const token = getAuthToken()
  if (!token) return null
  
  try {
    const payload = JSON.parse(atob(token.split('.')[1]))
    return payload.role || null
  } catch {
    return null
  }
}

export const isTokenExpired = (token: string): boolean => {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]))
    const currentTime = Date.now() / 1000
    return payload.exp < currentTime
  } catch {
    return true
  }
}
